
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-baebfcd2&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DynamicsDetail.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DynamicsDetail.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-baebfcd2!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DynamicsDetail.vue"),
  /* scopeId */
  "data-v-baebfcd2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductDynamics/DynamicsDetail.vue
// module id = 394
// module chunks = 0